import { Link } from '@tanstack/react-router';
import { Lock, Sparkles } from 'lucide-react';
import type { ReactNode } from 'react';
import { useSubscription } from '@/hooks/useSubscription';
import { useAuth } from '@/hooks/useAuth';

export function PremiumLock({
  children,
  title = 'Premium feature',
  description = 'Upgrade to LendyTrack Premium to unlock this.',
}: {
  children?: ReactNode;
  title?: string;
  description?: string;
}) {
  const { isPremium, loading } = useSubscription();
  const { user } = useAuth();

  if (loading) return <div className="h-32 animate-pulse rounded-xl bg-muted" />;
  if (isPremium) return <>{children}</>;

  return (
    <div className="relative overflow-hidden rounded-2xl border border-border bg-gradient-hero p-8 text-primary-foreground shadow-soft">
      <div className="absolute right-6 top-6 grid h-10 w-10 place-items-center rounded-full bg-accent text-primary">
        <Lock className="h-5 w-5" />
      </div>
      <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-accent">
        <Sparkles className="h-3 w-3" /> Premium
      </div>
      <h3 className="mt-2 font-display text-2xl font-semibold">{title}</h3>
      <p className="mt-2 max-w-md text-sm text-primary-foreground/80">{description}</p>
      <Link
        to={user ? '/pricing' : '/auth'}
        className="mt-5 inline-block rounded-md bg-accent px-4 py-2 text-sm font-semibold text-primary shadow-soft hover:opacity-90"
      >
        {user ? 'Upgrade — from $9.99/mo' : 'Sign in to upgrade'}
      </Link>
    </div>
  );
}
